'use client';

import Script from "next/script";
import { useEffect, useState } from "react";

export const Ads = () => {
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    window.addEventListener("IUBConsentGiven", () => {
      setConsentGiven(true);
    });
  }, []);

  return (
    <>
      {consentGiven && (
        <Script
          strategy="afterInteractive"
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4330595273799547"
          crossOrigin="anonymous"
        />
      )}
    </>
  );
};
